/**
 * Lee una variable de entorno con esta prioridad:
 *  1. window.__ENV__  → generado en runtime por nginx (producción / Cloud Run)
 *  2. import.meta.env → inyectado por Vite al compilar (desarrollo local con .env)
 *
 * Esto permite que el mismo artefacto Docker funcione en cualquier ambiente
 * sin recompilar: basta con cambiar las env vars en Cloud Run.
 */

declare global {
  interface Window {
    __ENV__?: Record<string, string>
  }
}

export function getEnv(key: string): string {
  const runtime = window.__ENV__?.[key]
  if (runtime) return runtime
  return (import.meta.env as Record<string, string>)[key] ?? ''
}
